export enum GraphPhotoSizes
{
	Original = "original",
	X48 = "48x48",
	X64 = "64x64",
	X96 = "96x96",
	X120 = "120x120",
	X240 = "240x240",
	X360 = "360x360",
	X432 = "432x432",
	X504 = "504x504",
	X648 = "648x648"
};

export enum GraphPresenceAvailabilities
{
	Available = "Available",
	AvailableIdle = "AvailableIdle",
	Away = "Away",
	BeRightBack = "BeRightBack",
	Busy = "Busy",
	BusyIdle = "BusyIdle",
	DoNotDisturb = "DoNotDisturb",
	Offline = "Offline",
	PresenceUnknown = "PresenceUnknown"
};
export enum GraphPresenceActivities
{
	Available = "Available",
	Away = "Away",
	BeRightBack = "BeRightBack",
	Busy = "Busy",
	DoNotDisturb = "DoNotDisturb",
	InACall = "InACall",
	InAConferenceCall = "InAConferenceCall",
	Inactive = "Inactive",
	InAMeeting = "InAMeeting",
	Offline = "Offline",
	OffWork = "OffWork",
	OutOfOffice = "OutOfOffice",
	PresenceUnknown = "PresenceUnknown",
	Presenting = "Presenting",
	UrgentInterruptionsOnly = "UrgentInterruptionsOnly"
};

export interface GraphArray<T>
{
	value: T[];
}

export interface GraphPresence
{
	id: string;
	availability: string;
	activity: string;
}

export interface GraphUserLite
{
	id: string;
	userPrincipalName: string;
}


export interface GraphBatchResponses
{
	responses: GraphBatchArgumentResponse[];
}
export interface GraphBatchArgumentResponse
{
	id: string;
	status: number;
	headers: any;
	body: any;
}